import React from 'react';
import { Button, Tooltip, Empty, Table} from 'antd';

import TableNivel1 from "./ResultList1";


export default class ResultList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <Table
                className={'logistica-table-kardex-almacen'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={{
                    total: this.props.pagination.total,
                    current: this.props.pagination.page,
                    pageSize: this.props.pagination.pageSize,
                    showTotal: (total) => `${total} Registro(s) encontrado(s).`
                }}
                dataSource={this.props.pagination.data}
                rowKey={record => record.id}

                onExpand={async (expanded, record) => {
                    await this.props.handleNivel0(0,expanded,record);
                }}
                expandedRowRender={(record) => {
                    return (
                        <div style={{ margin: '10px 0px' }}>
                            {
                                <TableNivel1 
                                dataSource={record.listaNivel}
                                handleSearchNivel1={this.props.handleSearchNivel1}
                                handleSearchNivel2={this.props.handleSearchNivel2} 
                                handleSearchNivel3={this.props.handleSearchNivel3} 
                                
                                handleNewNivel1={this.props.handleNewNivel1}
                                handleNewNivel2={this.props.handleNewNivel2} 
                                handleNewNivel3={this.props.handleNewNivel3} 
                                />
                            }
                        </div>
                    )
                }}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='No se encontraron datos.'
                    />
                }}
                columns={[
                    {
                        key: 'options',
                        align: 'center',
                        width: "70px",
                        render: (value, row) => (
                            <div className="custom-options">
                                <Tooltip placement="top" title={"Editar"}>
                                    <Button
                                        type="primary"
                                        icon="edit"
                                        size={"small"}
                                        style={{ display: (row.edit ? 'none' : '') }}
                                        onClick={() => { this.props.handleNivel0(row.id,false,row);}
                                         }
                                    />
                                </Tooltip>
                  
                                <Tooltip placement="top" title={"Cancelar"}>
                                    <Button
                                        icon="close"
                                        size={"small"}
                                        style={{ display: (row.edit ? '' : 'none') }}
                                        onClick={() => this.props.onEdit(0)}
                                    />
                                </Tooltip>
                            </div>
                        )
                    },
                    {
                        title: 'Elemento',
                        dataIndex: 'elemento',
                        key: 'elemento',
                        align: "center"
                    },
                    {
                        title: 'Código Cuenta',
                        dataIndex: 'codigoCuenta',
                        key: 'codigoCuenta',
                        align: "center"
                    },
                    {
                        title: 'Descripción',
                        dataIndex: 'descripcion',
                        key: 'descripcion',
                        align: "center"
                    },
                    {
                        title: 'Tipo Cuenta',
                        dataIndex: 'tipoCuenta',
                        key: 'tipoCuenta',
                        align: "center"
                    },
                    {
                        title: 'OP. Asociada',
                        dataIndex: 'OperacionAsociada',
                        key: 'OperacionAsociada',
                        align: "center"
                    },
               
                ]}
            />
        );
    }
}